import ProductListActions from "@GeriMed/Overrides/Widgets/ProductList/ProductListActions";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import ProductSearchScoreData from "@insite/content-library/Components/ProductSearchScoreData";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
// import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import ProductListProductInformation from "@GeriMed/Overrides/Widgets/ProductList/ProductListProductInformation";
import themeColors, { themeFontsSize } from "@GeriMed/styles/variables";
import siteMessage from "@insite/client-framework/SiteMessage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductCardStyles {
    gridContainer?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    actionsGridItem?: GridItemProps;
    searchScoreDataGridItem?: GridItemProps;
    sponsoredText?: TypographyPresentationProps;
    formularyLockoutMessage?: TypographyProps;
}

export const productCardStyles: ProductListProductCardStyles = {
    gridContainer: {
        gap: 0,
        css: css`
            padding: 15px;
            // min-width: 320px; /* prevent overlap with second column */

            .clickable-img {
                margin-bottom: 0;
            }
            .price-wrap {
                text-align: right;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            &.product-grid-item-wrap [class*="ButtonWrapper"] {
                                float: right;
                            }
                        `,
                    ],
                    "min",
                )}

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            &.product-grid-item-wrap [class*="ButtonWrapper"] {
                                width: auto;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    leftColumnGridItem: {
        width: [4, 4, 4, 3, 3],
        css: css`
            padding-right: 20px;
            flex-direction: column;
        `,
    },
    rightColumnGridItem: {
        width: [8, 8, 8, 9, 9],
    },
    infoGridItem: {
        width: [12, 12, 12, 7, 7],
    },
    actionsGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            flex-direction: column;
            align-items: flex-end;
        `
    },
    formularyLockoutMessage: {
        size: themeFontsSize.size14,
        color: themeColors.drakYellow,
        css: css`
            margin-bottom: 5px;
        `
    },
    searchScoreDataGridItem: {
        width: 12,
    },
    sponsoredText: {
        css: css`
            margin-bottom: 5px;
            font-size: 0.9em;
            opacity: 0.5;
        `,
    },
};

const styles = productCardStyles;

const ProductListProductCard: FC<Props> = props => {
    const isFormularyLockoutPoduct =
        !props.product.canAddToCart &&
        props.product.properties &&
        props.product.properties["customerHasFormularyLockout"] === "true" &&
        props.product.properties["onFormulary"] === "false";
    const isReverseFormularyLocked = !props.product.canAddToCart && props.product.properties['reverseFormularyLocked'] ==='true';
    return (
        <GridContainer
            className="product-grid-item-wrap"
            {...styles.gridContainer}
            data-test-selector={`productListProductCard${props.product.id}`}
        >
            <GridItem className="product-grid-item" {...styles.leftColumnGridItem}>
                {props.product.isSponsored && (
                    <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>
                )}
                <ProductListProductImage
                    showImage={props.showImage}
                    showCompare={props.showCompare}
                    showImageBadge={props.showImageBadges}
                    showTextBadge={props.showTextBadges}
                />
            </GridItem>
            <GridItem className="product-grid-item-right" {...styles.rightColumnGridItem}>
                <GridContainer {...styles.rightColumnGridContainer}>
                    <GridItem {...styles.infoGridItem}>
                        <ProductListProductInformation
                            showBrand={props.showBrand}
                            showTitle={props.showTitle}
                            showPartNumbers={props.showPartNumbers}
                            showAvailability={props.showAvailability}
                            showAttributes={props.showAttributes}
                            showImageBadges={props.showImageBadges}
                            maxImageBadges={props.maximumNumberOfImageBadges}
                            showTextBadges={props.showTextBadges}
                            maxTextBadges={props.maximumNumberOfTextBadges}
                        />
                    </GridItem>
                    <GridItem className="grid-item-right" {...styles.actionsGridItem}>
                        <ProductListActions showPrice={props.showPrice} showAddToList={props.showAddToList} />
                        {isFormularyLockoutPoduct && !isReverseFormularyLocked &&(
                            <Typography {...styles.formularyLockoutMessage}>{siteMessage("GM_Non_Formulary_Item_Msg")}</Typography>
                        )}
                        {isReverseFormularyLocked &&(
                            <Typography {...styles.formularyLockoutMessage}>{siteMessage("GM_ReverseFormularyLockout_Msg")}</Typography>
                        )}
                    </GridItem>
                    <GridItem {...styles.searchScoreDataGridItem}>
                        <ProductSearchScoreData />
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

export default withProduct(ProductListProductCard);
